module.exports = __webpack_public_path__ + "static/media/product-type_physical_goods.3968c84f.svg";